<div class="container padding-top padding-bottom">
  <md-card>
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class='btn btn-lg btn-primary'
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>Portable Settings</h1>
        <h3><b>{{locationData?.name}}</b></h3>
        <div *ngIf="!clientData?.portableMode"
             class="error">
          Warning: Portable Mode not enabled
        </div>
      </div>
    </div>

    <div *ngIf="!showLoading; else loading"
         class="row padding-bottom">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="locationData.portableInfo.isOnlyPortable">
              This location is portable units ONLY
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="locationData.portableInfo.useOnlyUnitsMarkedMobile">
              Only Show Units Marked 'Portable' in Sitelink on Portable Checkout
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="locationData.portableInfo.hidePortableUnitsOnRatesPage">
              Hide Units Marked 'Portable' in Sitelink on Rates Page
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <p>Drop Off Options (Defaults to all)</p>
            <p-multiSelect [styleClass]="'full-width'"
                           [options]="dropOffOptions"
                           [(ngModel)]="locationData.portableInfo.dropOffOptions"></p-multiSelect>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <p>Delivery Time Options (Defaults to all)</p>
            <p-multiSelect [styleClass]="'full-width'"
                           [options]="deliveryTimeOptions"
                           [(ngModel)]="locationData.portableInfo.deliveryTimeOptions"></p-multiSelect>
          </div>
          <div *ngIf="clientData?.portableInfo?.isDeliveryByZipCode"
               class="col-xs-12 col-md-6 sm-margin-top">
            <label>Delivery Zip Codes (comma-separated)</label>
            <input pInputText
                   [(ngModel)]="locationData.portableInfo.deliveryZipCodes" />
          </div>
          <div *ngIf="!clientData?.portableInfo?.isDeliveryByZipCode"
               class="col-xs-12 col-md-6 sm-margin-top">
            <label>Max Delivery Distance (miles/km for Canada)</label>
            <input pInputText
                   [(ngModel)]="locationData.portableInfo.maxDeliveryDistance" />
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Delivery Fee ID</label>
            <input pInputText
                   [(ngModel)]="locationData.portableInfo.deliveryFeeId" />
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Re-Delivery Fee ID</label>
            <input pInputText
                   [(ngModel)]="locationData.portableInfo.redeliveryFeeId" />
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Relocation Fee ID</label>
            <input pInputText
                   [(ngModel)]="locationData.portableInfo.relocationFeeId" />
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Move-In Fee ID</label>
            <input pInputText
                   [(ngModel)]="locationData.portableInfo.moveInFeeId" />
          </div>
          <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Final Pickup Fee ID</label>
            <input pInputText
                   [(ngModel)]="locationData.portableInfo.finalPickUpFeeId" />
          </div>
          <!-- <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Base Delivery Fee</label>
              <input pInputText
                     [(ngModel)]="locationData.portableInfo.baseDeliveryFee" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Number of Miles Included in Base Fee</label>
              <input pInputText
                     [(ngModel)]="locationData.portableInfo.numIncludedMiles" />
            </div> -->
        </div>
      </div>
      <div class="col-sm-6">
        <div *ngIf="!hideGetChargesButton; else chargesList"
             style="text-align:center">
          <button (click)="loadChargeTypes()"
                  class="btn btn-primary"
                  color="primary">Load Charge Types</button>
        </div>
        <ng-template #chargesList>
          <div class="charges-list"
               [innerHTML]="charges">
          </div>
        </ng-template>
      </div>
    </div>
    <div class="row padding-top">
      <div class="col-md-12">
        <button style="float: right;"
                (click)="updateLocation()"
                class="btn btn-lg btn-secondary"
                color="accent">Update</button>
      </div>
    </div>
  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-portable-settings/location-portable-settings.component.html